import React, {useContext, useState} from 'react';
import ReactDOM from 'react-dom';
import styles from './Modal.module.css';
import closeButton from '../../static_files/closeButtonHover.svg';
import UpgradeMembershipModal from './UpgradeMembershipModal';
import {SwapMainAppContext} from "../../context/SwapMainAppContext";
import goldBg from '../../static_files/buttonBackgroundGold.svg';

const defaultRobotDataStructure = {
    name: 'Robot Name',
    modalImageUrl: '',
    description: 'Robot description goes here.',
    tags: ['tag1', 'tag2'],
    productOverview: {
        'Detail 1': 'Value 1',
        'Detail 2': 'Value 2',
    },
    reserveLinkText: 'Learn more and reserve ',
    reserveLinkHref: '#',
    reserveLinkAnchorText: 'here'
};

function RobotModal({onClose, robotData = defaultRobotDataStructure, onOpenReserveForm, showPanel, setShowPanel}) {
    const displayData = {...defaultRobotDataStructure, ...robotData};
    const [showUpgradeModal, setShowUpgradeModal] = useState(false);
    const {
        userClass,
        setUserClass
    } = useContext(SwapMainAppContext);
    const [walletAddress, setWalletAddress] = useState(localStorage.getItem('walletAddress') || '');
    const [userEmail, setUserEmail] = useState(localStorage.getItem('userEmail') || '');
    const handleReserveClick = () => {
        const tempWalletAddress = localStorage.getItem('walletAddress');
        const tempUserEmail = localStorage.getItem('userEmail');
        if (walletAddress !== tempWalletAddress) {
            setUserEmail(tempWalletAddress)
        }
        if (userEmail !== tempUserEmail) {
            setWalletAddress(tempUserEmail)
        }
        if (!tempWalletAddress && !tempUserEmail) {
            if (setShowPanel) {
                setShowPanel(true);
                return;
            }
        } else {
            if (userClass === 'Explorer Member') {
                setShowUpgradeModal(true);
            } else {
                if (onOpenReserveForm) {
                    onOpenReserveForm(displayData.name);
                }
            }
        }
    };

    const handleUpgradeClose = () => {
        setShowUpgradeModal(false);
        onClose();
    };

    const handleUpgradeGoBack = () => {
        setShowUpgradeModal(false);
    };

    const handleUpgradeSuccess = () => {
        localStorage.setItem('userClass', 'Amplifier Member');
        setUserClass('Amplifier Member')
        setShowUpgradeModal(false);

        if (onOpenReserveForm) {
            onOpenReserveForm(displayData.name);
        }
    };

    const handleCryptoPayment = async (paymentData) => {
        return {success: true};
    };

    return (
        <>
            {!showUpgradeModal && ReactDOM.createPortal(
                <div className={styles.modalOverlay}
                     onClick={(e) => {
                         if (e.target === e.currentTarget) {
                             onClose();
                         }
                     }}>
                    <div className={styles.modalContainer}>
                        <div className={styles.headerRow}>
                            <img src={closeButton} className={styles.closeBtn} onClick={onClose} alt='Close modal'/>
                        </div>

                        <h2 className={styles.modalTitle}>{displayData.name}</h2>

                        <div className={styles.contentWrapper}>
                            <div className={styles.imageColumn}>
                                {displayData.modalImageUrl ? (
                                    <img src={displayData.modalImageUrl} alt={displayData.name}
                                         className={styles.robotImage}/>
                                ) : (
                                    <div className={styles.robotImagePlaceholder}>
                                        Robot Image Placeholder
                                    </div>
                                )}
                            </div>
                            <div className={styles.detailsColumn}>
                                <p className={styles.robotDescription}>{displayData.description}</p>

                                <div className={styles.tagsContainer}>
                                    {displayData.tags && displayData.tags.map((tag, index) => (
                                        <span key={index} className={styles.tag}>{tag}</span>
                                    ))}
                                </div>

                                <h3 className={styles.overviewTitle}>Product Overview</h3>
                                <div className={styles.overviewGrid}>
                                    {displayData.productOverview && Object.entries(displayData.productOverview).map(([key, value]) => (
                                        <div key={key} className={styles.overviewItem}>
                                            <span className={styles.overviewLabel}>{key}</span>
                                            <span className={styles.overviewValue}>{value}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className={styles.modalFooter}>
                            <p className={styles.footerText}>
                                {displayData.reserveLinkText}

                            </p>
                            <button
                                onClick={handleReserveClick}
                                className={styles.upgradeButton}
                                style={{backgroundImage: `url(${goldBg})`, width: '103px', backgroundSize: '500% 210%'}}
                            >
                                Reserve
                            </button>

                        </div>
                    </div>
                </div>,
                document.getElementById('root')
            )}

            {showUpgradeModal && (
                <UpgradeMembershipModal
                    onClose={handleUpgradeClose}
                    onGoBack={handleUpgradeGoBack}
                    membershipType="Amplifier"
                    price={99}
                    onTransactionTrigger={handleCryptoPayment}
                    onTransactionSuccess={handleUpgradeSuccess}
                />
            )}
        </>
    );
}

export default RobotModal;